import React from "react"
import { Link } from "gatsby"

import { Image } from "../Image/Image"
import { Video } from "../Video/Video"
import { withCallout } from "./withCallout"
import { Heading4, LargeBody } from "../Styled/Text"
import { CalloutCard, Media, Content } from "./CalloutStyle"

export const Callout = withCallout(({ callout, desktopImage, mobileImage, desktopVideo, mobileVideo, colsNumber, gridView }) => (
  <CalloutCard gridView={gridView} colsNumber={colsNumber} cols={callout?.displayColumns} rows={callout?.displayRows} backgroundColor={callout?.backgroundColor} textColor={callout?.textColor} as={Link} to={callout?.link}>
    <Media className="media-element" layout="desktop">
      {desktopVideo ? <Video url={desktopVideo} image={desktopImage} autoplay={true} /> : <Image image={desktopImage} fullHeight={true}  />}
    </Media>
    <Media className="media-element" layout="mobile">
      {mobileVideo ? (
        <Video url={mobileVideo} image={mobileImage || desktopImage} />
      ) : (
        <Image image={mobileImage || desktopImage} fullHeight={true} />
      )}
    </Media>
    {(callout?.content || callout?.title ) && <Content>
      {callout?.title && <Heading4>{callout?.title}</Heading4>}
      {callout?.content && <LargeBody>{callout?.content}</LargeBody>}
    </Content>}
  </CalloutCard>
))
